import { createReducer, on } from '@ngrx/store';
import * as DocumentDetailsMetaActions from './document-details-meta.actions';
import { DocumentDetailsMetaEntity } from './document-details-meta.models';

export const DOCUMENT_DETAILS_META_FEATURE_KEY = 'documentDetailsMeta';

export interface DocumentDetailsMetaState {
  documentDetailsMeta: DocumentDetailsMetaEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const initialDocumentDetailsMetaState: DocumentDetailsMetaState = {
  documentDetailsMeta: null,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialDocumentDetailsMetaState,
  on(DocumentDetailsMetaActions.initDocumentDetailsMeta, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(DocumentDetailsMetaActions.loadDocumentDetailsMetaSuccess, (state, { documentDetailsMeta }) => ({
    ...state,
    documentDetailsMeta,
    loaded: true,
    error: null,
  })),
  on(DocumentDetailsMetaActions.loadDocumentDetailsMetaFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error,
  })),
  on(DocumentDetailsMetaActions.clearDocumentDetailsMeta, () => initialDocumentDetailsMetaState)
);

export function documentDetailsMetaReducer(state: DocumentDetailsMetaState | undefined, action: any) {
  return reducer(state, action);
}
